import {forwardRef, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {Text, TextProps} from "@mantine/core";

export type DefaultTextProps = TextProps & {
  value?: string | number;
  defaultValue?: string;
};

export const DefaultText = forwardRef<HTMLDivElement, DefaultTextProps>((props, ref) => {
  const {value, defaultValue, ...rest} = props;

  const {t} = useTranslation(["common"]);

  const defaultNode: string = useMemo(() => {
    if (typeof defaultValue !== "undefined") {
      return String(defaultValue)
    } else {
      return t("common.unknown", "Unknown")
    }
  }, [defaultValue, t]);

  return (
    <Text ref={ref} {...rest}>
      {value ?? defaultNode}
    </Text>
  )
})
